import { render } from "./UserAuth.vue?vue&type=template&id=67c0290a"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"
script.render = render

export default script